import { Box, Typography } from '@mui/material';
import { FallbackProps } from 'react-error-boundary';
import { styles } from './ErrorFallback.styles';
import { LandscapeSvg } from './LandscapeSvg';
import React from 'react';
import locale from './errorFallback-locale.json';
import { ErrorCodes, ErrorMessage } from './fallback.types';

type Props = {
  error: Error;
  resetErrorBoundary: FallbackProps['resetErrorBoundary'];
};

export function ErrorFallback({ error }: Props) {
  const errorMessage = error.message as ErrorMessage;

  const errorCode = ErrorCodes[errorMessage] || '';

  return (
    <Box sx={errorCode ? { ...styles.container, ...styles.withErrorCode } : styles.container} data-test="errorFallback">
      {errorCode ? <Box sx={styles.errorCode}>{errorCode}</Box> : null}

      <LandscapeSvg size="medium" />
      <Typography variant="h3" sx={styles.header}>
        {errorMessage === ErrorMessage.NotFound ? locale.pageDoesNotExist : locale.somethingWentWrong}
      </Typography>
      <Typography variant="h4" sx={styles.supportText}>
        Try refreshing the page or contact {''}
        <a href="https://support.opengov.com/hc/en-us" target="_blank" rel="noopener noreferrer">
          support
        </a>{' '}
        if the error persists.
      </Typography>
    </Box>
  );
}
